import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import SelectProviderListItem from "../common/SelectProviderListItem";
import { faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import { PreloadState } from "../UI/preloading/PreloadState";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateDebtToPayForm = ({
  debttopay,
  handleSubmitData,
  handler,
  providers,
  setRedirect,
  setRedirectUrl,
  isAdd,
  debttopayId,
  setIsAdd,
}) => {
  const moduleBase = useModuleBase();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    setValue,
    setError,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const { nextPage, previousPage, perPage, goToPage, meta } = handler;
  const { baseCurrency } = useContext(CurrencyContext);

  const [imagePreview, setImagePreview] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [amount, setAmount] = useState(null);
  const [details, setDetails] = useState("");
  const [name, setName] = useState("");
  const [collapseOne, collapseOneOpen] = useState(false);

  register("provider");
  register("amount");
  register("details");

  useEffect(() => {
    if (selectedProvider) {
      setValue("provider", selectedProvider);
      clearErrors("provider");
    }
    if (!selectedProvider) {
      setError("provider", {
        message: "Debes seleccionar un proveedor",
      });
    }
    // eslint-disable-next-line
  }, [selectedProvider]);

  useEffect(() => {
    if (debttopay) {
      if (debttopay.voucher) {
        setImagePreview(
          `${import.meta.env.VITE_URL}/storage/${debttopay.voucher}`
        );
      }
      setDetails(debttopay.details);
      setAmount(debttopay.amount);
      setName(debttopay.name);
      setSelectedProvider(debttopay.provider.id);
    }
  }, [debttopay]);

  useEffect(() => {
    setValue("amount", amount);
    setValue("details", details);
    setValue("name", name);
    if (!name) {
      setError("name", { message: "El nombre es requerido." });
    } else {
      clearErrors("name");
    }
    if (!details) {
      setError("details", { message: "El detalle es requerido." });
    } else {
      if (details.length < 5) {
        setError("details", {
          message: "El detalle debe contener al menos 5 caracteres.",
        });
      } else {
        clearErrors("details");
      }
    }
    if (!amount) {
      setError("amount", { message: "Ingrese un monto válido" });
    } else {
      clearErrors("amount");
    }
    // eslint-disable-next-line
  }, [details, amount]);

  const renderProvidersItems = () => {
    return providers.map((provider) => {
      return (
        <SelectProviderListItem
          avatar={"https://picsum.photos/200/200"}
          onSelect={() => {
            if (!debttopay) {
              setSelectedProvider(provider.id);
            }
          }}
          selected={selectedProvider}
          id={provider.id}
          key={provider.id}
          title={provider.name}
          toDeleteId={provider.id}
          toEditId={provider.id}
          createdAt={provider.created_at}
          alternativeName="proveedor"
        />
      );
    });
  };

  const renderProvidersItemsAdd = () => {
    return providers.map((provider) => {
      return (
        <SelectProviderListItem
          avatar={"https://picsum.photos/200/200"}
          onSelect={() => {
            setSelectedProvider(provider.id);
          }}
          selected={selectedProvider}
          id={provider.id}
          key={provider.id}
          title={provider.name}
          toDeleteId={provider.id}
          toEditId={provider.id}
          createdAt={provider.created_at}
          alternativeName="proveedor"
        />
      );
    });
  };

  const handleImageChange = (event) => {
    if (event.target.files.length !== 0) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
      register("voucher");
      setValue("voucher", event.target.files[0]);
    }
  };

  return (
    <>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-light"
        onSubmit={handleSubmit(handleSubmitData)}
      >
        <PreloadState
          loading={isSubmitting}
          message="Guardando cuenta por pagar..."
        >
          <>
            <FalconCardHeader
              title="Detalle de cuenta por pagar"
              light={false}
            />
            <CardBody>
              <Row form>
                <Col sm tag={FormGroup}>
                  <Label>Seleccione un proveedor de la lista</Label>
                  {!debttopayId
                    ? renderProvidersItems()
                    : renderProvidersItemsAdd()}
                  <FullPagination
                    nextPage={nextPage}
                    prevPage={previousPage}
                    goToPage={goToPage}
                    meta={meta}
                    className={"shadow-none"}
                    posText={"proveedores"}
                    perPage={perPage}
                  />
                  <WizardError
                    error={errors.provider?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>
              <Row form>
                <Col sm tag={FormGroup}>
                  <Label for="acronym">Monto</Label>
                  <NumberFormat
                    fixedDecimalScale={true}
                    prefix={`${baseCurrency.symbol} `}
                    decimalScale={2}
                    disabled={!!debttopay}
                    value={amount}
                    className={`${errors.amount?.message ? "border-danger" : ""
                      } form-control`}
                    placeholder="Monto"
                    onValueChange={({ value }) => {
                      setAmount(value);
                    }}
                    thousandSeparator={true}
                    renderText={(value, props) => <div {...props}>{value}</div>}
                  />
                  <WizardError
                    error={errors.amount?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>

              {!debttopay && (
                <Row form>
                  <Col sm tag={FormGroup}>
                    <Label for="acronym">Factura del proveedor</Label>
                    <Input
                      name="voucher"
                      id="voucher"
                      placeholder="Adjunte la factura del proveedor"
                      onChange={handleImageChange}
                      accept="image/png, image/jpeg"
                      disabled={!!debttopay}
                      type="file"
                      className={classNames({
                        "border-danger": errors.voucher?.message,
                      })}
                    />
                    <WizardError
                      error={errors.voucher?.message}
                      className="fs--1 font-weight-normal d-block"
                    />
                  </Col>
                </Row>
              )}

              {imagePreview && (
                <Row form>
                  <Col
                    style={{
                      backgroundImage: `url(${imagePreview})`,
                      backgroundSize: "contain",
                      height: "400px",
                      width: "400px",
                      maxHeight: "400px",
                      maxWidth: "400px",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></Col>
                </Row>
              )}
              <Row form>
                <Col sm>
                  <Label for="details">Nombre de la cuenta a pagar</Label>
                  <Input
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                    value={name}
                    disabled={!!debttopay}
                    rows={6}
                    placeholder="Ingrese un nombre de la cuenta a pagar"
                    className={classNames({
                      "border-danger": errors.name?.message,
                    })}
                  />
                  <WizardError
                    error={errors.name?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>
              <Row form>
                <Col sm>
                  <Label for="details">Descripcion de la cuenta a pagar</Label>
                  <Input
                    onChange={(event) => {
                      setDetails(event.target.value);
                    }}
                    value={details}
                    type="textarea"
                    disabled={!!debttopay}
                    rows={6}
                    placeholder="Ingrese un detalle de la cuenta a pagar"
                    className={classNames({
                      "border-danger": errors.details?.message,
                    })}
                  />
                  <WizardError
                    error={errors.details?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>
            </CardBody>
            {!debttopay && (
              <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
                <ButtonIcon
                  color="falcon-default"
                  className="ml-auto px-5 mr-2"
                  icon={faUndo}
                  onClick={() => {
                    setRedirectUrl(`/dashboard/${moduleBase}/${id}/receivable`);
                    setRedirect(true);
                  }}
                  iconAlign="right"
                  transform="down-1 shrink-4"
                >
                  Volver
                </ButtonIcon>
                <ButtonIcon
                  color="primary"
                  className="px-5"
                  onClick={() => collapseOneOpen(!collapseOne)}
                  icon="save"
                  disabled={Object.keys(errors).length > 0}
                  iconAlign="right"
                  transform="down-1 shrink-4"
                >
                  Guardar
                </ButtonIcon>
              </CardFooter>
            )}
            <Modal isOpen={collapseOne} data-testid="modal">
              <ModalHeader>Confirmación</ModalHeader>
              <ModalBody>
                <p className="mb-0 font-weight-bold fs--1">
                  ¿Está seguro de que ingresó todos los datos correctamente?
                  Esta información no puede ser cambiada posteriormente.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => collapseOneOpen(!collapseOne)}>
                  Cancelar
                </Button>
                <Button
                  data-testid="submit-button"
                  color="primary"
                  type="submit"
                  disabled={Object.keys(errors).length > 0}
                  onClick={handleSubmit(handleSubmitData)}
                >
                  Sí, registrar
                </Button>
              </ModalFooter>
            </Modal>
          </>
        </PreloadState>
      </Card>
      <br />
      {debttopay && (
        <Card>
          <FalconCardHeader
            title="Facturas adicionales"
            // eslint-disable-next-line react/no-children-prop
            children={
              <ButtonIcon
                color="falcon-default"
                icon={faPlus}
                onClick={() => setIsAdd(!isAdd)}
              >
                {!isAdd ? "Agregar" : "Ocultar"}
              </ButtonIcon>
            }
          />
        </Card>
      )}
    </>
  );
};

export default withRedirect(CreateDebtToPayForm);
